import { TrackerTypes } from '../models/tracker-types.interface';
import { Tracker } from '../models/tracker.interface';
import { TrackingService } from '../services/tracking.service';
import { TrackerType } from '..';

export interface TrackerFactory<T extends keyof TrackerTypes> {
  readonly type: TrackerType;
  create(service: TrackingService, config: TrackerTypes[T]): Tracker | undefined;
}
